import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {ExcTableConfig} from 'exc-controls';
import {ExcFilter, ExcFilterCondition, ExcSort, FilterSortService} from '../../filter-sort-service.service';
import {audit} from 'rxjs/operators';
import {ActivatedRoute} from '@angular/router';
import {ModalCancelAuditComponent} from '../../modals/modal-cancel-audit/modal-cancel-audit.component';
import {ExcSigninService} from 'exc-signin';
import {ModalProviderEditAuditComponent} from '../../modals/modal-provider-edit-audit/modal-provider-edit-audit.component';
import {ExcTab} from 'exc-tab';
import {ModalAssignAuditComponent} from '../../modals/modal-assign-audit/modal-assign-audit.component';
import {ModalPlanAuditComponent} from '../../modals/modal-plan-audit/modal-plan-audit.component';
import {ProviderAuditDetailsComponent} from '../provider-audit-details/provider-audit-details.component';

@Component({
  selector: 'app-provider-audit-list',
  templateUrl: './provider-audit-list.component.html',
  styles: []
})
export class ProviderAuditListComponent extends ExcTranslation implements OnInit {
  @ViewChild('filterMenu') filterMenu;
  // auditListConfig: ExcListConfig = new ExcListConfig();
  auditTableConfig: ExcTableConfig = new ExcTableConfig();
  auditListData: any[];
  clients: any[];
  searchValue = '';
  optionsMonth: any[] = [];
  optionsYear: any[] = [];
  private _statusFilter: { value: number, key: string, considerFilter: boolean }[] = [];
  public sortValue: { key: 'asc' | 'desc' } | {} = {};
  public sortData: ExcSort[] = [];
  popupData = {Year: (new Date()).getFullYear(), Month: (new Date()).getMonth() + 1  };
  selectedClient = '0';
  lstFilters: ExcFilter[] = [];
  auditors: [];
  auditTypes: number[] = [];
  get StatusFilter(): any[] {
    return this._statusFilter;
  }
  set StatusFilter(value: any[]) {
    const _self = this;
    if (_self._statusFilter.length > 0) {
      return;
    }
    _self._statusFilter = [];
    value.forEach((status) => {
      if (status !== 6 && status !== 9 && status !== 5 && status !== 7) {
      _self._statusFilter.push({
        value: status,
        get key() {
          return _self.getGlobal('AuditState_' + status );
        },
        considerFilter: false
      });
      }
    });
  }


  constructor(private excRest: ExcRestService, private excSec: ExcSigninService, private excFss: FilterSortService, private route: ActivatedRoute) {
    super();
    const _self = this;
    _self.setSortData();
    _self.lstFilters =  [
        new ExcFilter(1, 'Status', 'AuditStateFilter', new ExcFilterCondition('=', '1'), 'fltStatus1', 'Globals.AuditState_1', false)
      , new ExcFilter(1, 'Status', 'AuditStateFilter', new ExcFilterCondition('=', '2'), 'fltStatus2', 'Globals.AuditState_2', false)
      , new ExcFilter(1, 'Status', 'AuditStateFilter', new ExcFilterCondition('=', '3'), 'fltStatus3', 'Globals.AuditState_3', false)
      , new ExcFilter(1, 'Status', 'AuditStateFilter', new ExcFilterCondition('=', '4'), 'fltStatus4', 'Globals.AuditState_4', false)
      , new ExcFilter(1, 'Status', 'AuditStateFilter', new ExcFilterCondition('=', '8'), 'fltStatus8', 'Globals.AuditState_8', false)
      , new ExcFilter(1, 'Status', 'AuditStateFilter', new ExcFilterCondition('=', '10'), 'fltStatus10', 'Globals.AuditState_10', false)
      , new ExcFilter(2, 'ddl1', 'MdtID', new ExcFilterCondition('=', ''), 'fltClientID', _self.getRessource('MandantName'), false)
      , new ExcFilter(2, 'ddl2', 'AuditType', new ExcFilterCondition('=', ''), 'fltAuditType', _self.getGlobal('AuditType'), false)
      , new ExcFilter(2, 'textbox', 'AuditID', new ExcFilterCondition('=', ''), 'fltAuditID', _self.getRessource('AuditID'), false)
      , new ExcFilter(2, 'textbox', 'DealerName', new ExcFilterCondition('like', ''), 'fltDealerName', _self.getRessource('DealerName'), false)
      , new ExcFilter(2, 'textbox', 'AuditorName', new ExcFilterCondition('like', ''), 'fltAuditorName', _self.getRessource('Auditor'), false)
    ];

    for (const x of _self.lstFilters) {
      x.Container = _self.lstFilters;
    }
    for (let i = 1; i <= 12; i++) {
      _self.optionsMonth.push({text: i, value: i});
    }
    for (let i = -3; i <= 3; i++) {
      _self.optionsYear.push({text: (new Date()).getFullYear() + i, value: (new Date()).getFullYear() + i});
    }
    _self.auditTypes.push(1);
    _self.auditTypes.push(6);
    _self.auditTypes.push(8);
    _self.auditTableConfig.OnRefresh = () => {
      _self.loadAudits();
    };
    _self.auditTableConfig.OnPageChanged = (pageNo) => {
    _self.auditTableConfig.paging.pageNo = pageNo;
      _self.loadAudits();
    };
    _self.auditTableConfig.OnSearch = (searchValue) => {
      _self.searchValue = searchValue;
      _self.loadAudits();
    };
    _self.auditTableConfig.OnFilterClick = (event?) => _self.filterMenu.toggle(event);
    _self.auditTableConfig.OnFilter = () => {
    };
  }

  ngOnInit() {
    const _self = this;
    const flt = _self.route.snapshot.paramMap.get('flt');
    if (flt !== null) {
      if (_self.excFss.ApplyPresetFilter(flt, _self.lstFilters)) {
        _self.auditTableConfig.MetaInfo.dataFilter = {flt: flt};
      }
    }
    _self.loadAudits();
  }

  loadAudits() {
     const _self = this;
     let metainfo = _self.auditTableConfig.GetMetaInfo();
     metainfo =  _self.excFss.ApplyFilter(metainfo, _self.lstFilters, _self.sortData);
    _self.auditTableConfig.MetaInfo.dataFilter = metainfo.dataFilter;
    _self.auditTableConfig.MetaInfo.dataSort = metainfo.dataSort;
    _self.auditTableConfig.isLoading = true;
    _self.excRest.sget(this.excRest.computeUrl('AuditR_ProviderList',
      {fts: _self.searchValue,
        month: _self.popupData.Month,
        year: _self.popupData.Year}), ExcCoreModule.Guid.NewGuid(),
      {MetaInfo: metainfo})
      .subscribe(response => {
        if (response.response !== undefined && response.response !== null) {
          _self.auditListData = response.response.data.Audits;
          _self.clients = response.response.data.Clients;
          _self.auditTableConfig.isLoading = false;
          _self.auditTableConfig.paging = response.response.paging.Audits;
        }
      });
  }
  getAvatarClass(data) {
    const _self = this;
  }
  applyFilter() {
    const _self = this;
    _self.filterMenu.hide();
    _self.loadAudits();
  }
  resetFilter() {
    const _self = this;
    _self.popupData = {Year: (new Date()).getFullYear(), Month: (new Date()).getMonth() + 1  };
    _self.excFss.ResetFilter(_self.lstFilters, _self.sortData);
    _self.auditTableConfig.MetaInfo.dataSort =  {};
    _self.auditTableConfig.MetaInfo.dataFilter = {};
    _self.filterMenu.hide();
    _self.loadAudits();
  }
  resetSort() {
    const _self = this;
    _self.setSortData();
    _self.sortValue = {};
    _self.auditTableConfig.MetaInfo.dataSort = this.sortValue;
  }
  resetFilterElement () {
    const _self = this;
    _self.selectedClient = '0';
    _self.StatusFilter.forEach(statusObject => statusObject.considerFilter = false);
    _self.auditTableConfig.MetaInfo.dataFilter = {};
  }
  setSortData() {
    const _self = this;
    _self.sortData = [
        new ExcSort('DealerName', 0, 'ProviderAuditListComponent.DealerName', 0)
      , new ExcSort('DealerLevel1', 0, 'ProviderAuditListComponent.DealerID', 0)
      , new ExcSort('AuditorName', 0, 'ProviderAuditListComponent.Auditor', 0)
      , new ExcSort('AuditState', 0, 'ProviderAuditListComponent.State', 0)
      , new ExcSort('AuditDate', 0, 'ProviderAuditListComponent.AuditDateLabel', 0)
      , new ExcSort('Mandant', 0, 'ProviderAuditListComponent.MandantName', 0)
    ];
    for (const x of _self.sortData) {
      if (x !== undefined) {
        x.Container = _self.sortData;
      }
    }
  }
  isCancelable(item: any) {
    const _self = this;
    return _self.excSec.isFeatured('PRV_ADT_CU')
      && item.AuditState < 8;
  }
  isPlanable(item: any) {
    const _self = this;
    return _self.excSec.isFeatured('PRV_ADT_CU')
      && (item.AuditState === 2) ;
  }
  isRePlanable(item) {
    const _self = this;
    return _self.excSec.isFeatured('PRV_ADT_CU')
      && (item.AuditState >= 3 && item.AuditState < 5) ;
  }
  isReAssignable(item) {
    const _self = this;
    return _self.excSec.isFeatured('PRV_DISP_R')
      && (item.AuditState >= 2 && item.AuditState < 5) ;
  }
  isAssignable(item: any) {
    const _self = this;
    return _self.excSec.isFeatured('PRV_DISP_R')
      && item.AuditState === 1; // bis vorbereitet
  }
  assignAudit(data) {
    const _self = this;
    const url = _self.excRest.computeUrl('AuditorR_ProviderList');
    _self.excRest.sget(this.excRest.computeUrl(url, {
      }),
      ExcCoreModule.Guid.NewGuid(), {})
      .subscribe(response => {
        if (response.response !== undefined && response.response !== null) {
          _self.auditors = response.response.data;
          ExcCoreModule.showModal(ModalAssignAuditComponent, null, 's',
            { data: data, auditors: _self.auditors}, false, null).subscribe(ret => {
            if (ret.proceed === true) {
              if (ret.auditor !== null) {
                _self.excRest.put(_self.excRest.computeUrl('AuditorU_ProviderAssign', {AuditID: data.AuditID}),
                  {
                    AuditID: data.AuditID,
                    AdmID: ret.auditor
                  }, {}, false)
                  .subscribe(ans => {
                    _self.loadAudits();
                  });
              }
            }
          });
        }
      });

  }
  isEditable (item: any) {
    return  item.AuditState < 7;
  }
  planAudit(data) {
    const _self = this;
    ExcCoreModule.showModal(ModalPlanAuditComponent, null, 's',
            { PlanData: data.AuditDate}, false, null).subscribe(ret => {
            if (ret.proceed === true) {
              if (ret.planDate !== null) {
                const d = new Date(ret.planDate).toLocaleString('de-DE');
                   _self.excRest.put(_self.excRest.computeUrl('AuditorU_ProviderPlan', {AuditID: data.AuditID}),
                  { AuditDate: d}, {}, false)
                  .subscribe(response => {
                    _self.loadAudits();
                  });
              }
            }
          });
  }
  cancelAudit(data) {
    const _self = this;
    const warningMessage = _self.getRessource('Warning');
    ExcCoreModule.showModal(warningMessage, _self.getRessource('CancelAudit'), 's', null, true, [ {
      text: this.getGlobal('No'),
      class: 'btn btn-submit',
      onClick: (overlay) => {
        overlay.close(false);
      }
    }, {
      text: this.getGlobal('Yes'),
      class: 'btn btn-submit',
      onClick: (overlay) => {
        overlay.close(true);
       //////////////////////////////
        let contacs = [];
        const url = _self.excRest.computeUrl('Provider_ClientContactR_List');
        _self.excRest.sget(this.excRest.computeUrl(url, {
            AuditID:  data.AuditID
          }),
          ExcCoreModule.Guid.NewGuid(), {})
          .subscribe(response => {
            if (response.response !== undefined && response.response !== null) {
              contacs = response.response.data;
              ExcCoreModule.showModal(ModalCancelAuditComponent, null, 'l',
                { Contacs: contacs}, false, null).subscribe(ret => {
                if (ret.proceed === true) {
                  if (ret.CancellationReason !== null && ret.Comment !== null) {
                    _self.excRest.put(_self.excRest.computeUrl('Provider_AuditU_Cancel', {AuditID: data.AuditID}),
                      {
                        CancellationReason: ret.CancellationReason,
                        Comment: ret.Comment
                      }, {}, false)
                      .subscribe(ans => {
                        _self.loadAudits();
                      });
                  }
                }
              });
            }
          });
        ////////////////////////////////
      }
    }]).subscribe(x => {
    });
  }
  getComment(data) {
    const _self = this;
    if (data.AuditState !== 10) {
      return data.AuditComment;
    } else {
      if (data.AuditComment.indexOf('<') === 0) {
        let str = data.AuditComment;
        let elements: string[];
        let element;
        elements = [];
        while (str.length > 0) {
          const mys = str.substring(str.indexOf('<') + 1, str.indexOf('>'));
          elements.push(mys);
          element = '<' + mys + '>';
          str.replace('<' + mys + '>' , '');
          str = str.replace(element, '');
        }
        let returnStr = '';
        returnStr = _self.getRessource('CancelAuditComment', {ContactType: elements[0], Date: elements[1], Contact: elements[2], Comment: elements[3]  }) ;
        return returnStr;
      } else {
        return data.AuditComment;
      }
    }
  }
  editProviderAudit (data) {
    const _self = this;
    ExcCoreModule.showModal(ModalProviderEditAuditComponent, null, 'm',
      { data: data}, false, null).subscribe(ret => {
      if (ret.proceed === true) {
        if (ret.AuditObject !== null) {
          _self.excRest.put(_self.excRest.computeUrl('Provider_AuditU', {AuditID: data.AuditID}),
            {
              AuditID: data.AuditID,
              AuditMonth:  ret.AuditObject.AuditMonth,
              AuditYear:  ret.AuditObject.AuditYear,
              AuditTargetDate: ret.AuditObject.AuditTargetDate,
              AuditPriority:  ret.AuditObject.AuditPriority
            }, {}, false)
            .subscribe(response => {
              _self.loadAudits();
            });
        }
      }
    });
  }
  openAudit(item) {
    new ExcTab(item.DealerName + ' - ' + item.AuditID, ProviderAuditDetailsComponent, item, item.AuditID, {
      Unique: true, ReloadParent: function () {
      }
    }, true).Open();
  }
  getAuditStatus (status) {
    const _self = this;
    return _self.getGlobal('AuditState_' + status );
  }
}
